import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            "InstrumentationKey=84a6fd0a-639f-49c4-9b2b-b45e795b4b93;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/;ApplicationId=8c1713dd-80dc-4c43-ba5d-3fb8736b6fda"
    }
});
appInsights.loadAppInsights();

export { appInsights };
